import { useState, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Row } from "react-bootstrap";
import API from "../../axios";
import OrderStatusView from "../../components/CustomerShippingView/OrderStatusView";
import CustomerInfoTable from "../../components/CustomerShippingView/CustomerInfoTable";
import { json2csv } from "json-2-csv";

interface ShippingRecord {
    name: string;
    qtyOrdered: number;
    qtyShipped: number;
    qtyReceived: number;
    products: any[];
    isSpareParts?: boolean;
}

const CustomerShippingViewFullScreen = () => {
    const [products, setProducts] = useState<any[]>([]);
    const [shippingData, setShippingData] = useState<ShippingRecord[]>([]);
    const [shippedShippingData, setShippedShippingData] = useState<
        ShippingRecord[]
    >([]);
    const [receivedShippingData, setReceivedShippingData] = useState<
        ShippingRecord[]
    >([]);

    const [partsShippingData, setPartsShippingData] = useState<
        ShippingRecord[]
    >([]);
    const [currentFilter, setCurrentFilter] = useState("all");

    const [openedSoNumber, setOpenedSoNumber] = useState(false);

    const [totalQty, setTotalQty] = useState(0);
    const [totalFilteredShippedQty, setTotalFilteredShippedQty] = useState(0);
    const [totalFilteredReceivedQty, setTotalFilteredReceivedQty] = useState(0);

    const [totalReceivedQty, setTotalReceivedQty] = useState(0);
    const [totalShippedQty, setTotalShippedQty] = useState(0);
    const [totalNotShippedQty, setTotalNotShippedQty] = useState(0);
    const [totalRemainingQty, setTotalRemainingQty] = useState(0);

    const [sparePartsTotalQty, setSparePartsTotalQty] = useState(0);
    const [sparePartsTotalReceivedQty, setSparePartsTotalReceivedQty] =
        useState(0);
    const [sparePartsTotalShippedQty, setSparePartsTotalShippedQty] =
        useState(0);
    const [sparePartsTotalNotShippedQty, setSparePartsTotalNotShippedQty] =
        useState(0);
    const [sparePartsTotalRemainingQty, setSparePartsTotalRemainingQty] =
        useState(0);

    const [isSearchOpen, setIsSearchOpen] = useState(false);

    const suggestions = ["So Name"];

    const [loading, setLoading] = useState(true);

    const [search, setSearch] = useState("");
    const [poNumber, setPoNumber] = useState("");
    const [soName, setSoName] = useState("");
    const [vendorReference, setVendorReference] = useState("");
    const [productName, setProductName] = useState("");

    /**
     * To sync two tables left and right
     */
    const leftScrollRef = useRef<HTMLDivElement | null>(null);
    const rightScrollRef = useRef<HTMLDivElement | null>(null);
    const isSyncing = useRef(false);

    const [shippingInfoColumns, setShippingInfoColumns] = useState([
        {
            name: "SO Number",
            visiable: true,
        },
        {
            name: "Product",
            visiable: true,
        },
        {
            name: "Ordered",
            visiable: true,
        },
        {
            name: "Not Shipped",
            visiable: true,
        },
        {
            name: "Shipped",
            visiable: true,
        },
        {
            name: "Delivered",
            visiable: true,
        },
    ]);

    function getMonthDates(
        targetMonth: number,
        targetYear: number,
    ): { startDate: string; endDate: string } {
        const startDate = new Date(targetYear, targetMonth - 1, 1);
        const endDate = new Date(targetYear, targetMonth, 0);

        const formatDate = (date: Date): string => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        };

        return {
            startDate: formatDate(startDate),
            endDate: formatDate(endDate),
        };
    }

    async function handleSearch(item?: string) {
        setIsSearchOpen(false);
        setLoading(true);

        try {
            let filter: any = {};

            if (item) {
                if (item == "PO Number") filter.poNumber = search.trim();
                else if (item == "Vendor Ref")
                    filter.vendorReference = search.trim();
                else if (item == "So Name") filter.soNumber = search.trim();
                else if (item == "Product Name")
                    filter.productName = search.trim();

                let result: any;
                result = await API.getSoList(filter);
                console.log(result);

                /**
                 * Seperate parts and vehicle shipping datas
                 */
                let lShippingData: any = [];
                let lPartsShippingData: any = [];
                for (let i = 0; i < result.length; i++) {
                    const data = result[i];

                    if (data.isSpareParts) {
                        lPartsShippingData.push(data);
                    } else {
                        lShippingData.push(data);
                    }
                }
                console.log("shipping data: ", lShippingData);

                setShippingData(lShippingData);
                setPartsShippingData(lPartsShippingData);

                let ltotalQty = 0;
                let ltotalReceivedQty = 0;
                let ltotalShippedQty = 0;
                let ltotalNotShippedQty = 0;
                for (let i = 0; i < lShippingData.length; i++) {
                    const element = result[i];
                    ltotalQty += element?.qtyOrdered;
                    ltotalReceivedQty += element.qtyReceived;
                    ltotalShippedQty += element.qtyShipped;
                    ltotalNotShippedQty += element.qtyNotShipped;
                }
                // setTotalQty(ltotalQty);
                // setTotalReceivedQty(totalReceivedQty);
                // setTotalShippedQty(ltotalShippedQty);
                // setTotalNotShippedQty(ltotalNotShippedQty);

                let lsparePartsTotalQty = 0;
                let lsparePartsTotalReceivedQty = 0;
                let lsparePartsTotalShippedQty = 0;
                let lsparePartsTotalNotShippedQty = 0;
                for (let i = 0; i < lPartsShippingData.length; i++) {
                    const element = result[i];
                    lsparePartsTotalQty += element?.qtyOrdered;
                    lsparePartsTotalReceivedQty += element.qtyReceived;
                    lsparePartsTotalShippedQty += element.qtyShipped;
                    lsparePartsTotalNotShippedQty += element.qtyNotShipped;
                }
                // setLoading(false);
                // setSparePartsTotalQty(lsparePartsTotalQty);
                // setSparePartsTotalReceivedQty(lsparePartsTotalReceivedQty);
                // setSparePartsTotalShippedQty(lsparePartsTotalShippedQty);
                // setSparePartsTotalNotShippedQty(lsparePartsTotalNotShippedQty);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function handleClearSearch() {
        setSoName("");
        setProductName("");

        loadShippingData();
    }

    async function loadShippingData(params: any = {}) {
        setLoading(true);

        try {
            const result: any = await API.getSoList();

            /**
             * Seperate parts and vehicle shipping datas
             */
            let lShippingData: any = [];
            let lPartsShippingData: any = [];
            for (let i = 0; i < result.length; i++) {
                const data = result[i];

                if (data.isSpareParts) {
                    lPartsShippingData.push(data);
                } else {
                    lShippingData.push(data);
                }
            }

            setShippingData(lShippingData);
            setPartsShippingData(lPartsShippingData);

            let products: any[] = [];
            let ltotalQty = 0;
            let ltotalReceivedQty = 0;
            let ltotalShippedQty = 0;
            let lttoalNotShippedQty = 0;
            let lttoalRemainingQty = 0;
            for (let i = 0; i < lShippingData.length; i++) {
                const element = lShippingData[i];
                ltotalQty += element?.qtyOrdered;
                ltotalReceivedQty += element.qtyReceived;
                ltotalShippedQty += element.qtyShipped;
                lttoalNotShippedQty += element.qtyNotShipped;
                lttoalRemainingQty += element.qtyRemaining;

                for (let j = 0; j < element.products.length; j++) {
                    element.products[j].soName = element.name;
                }
                products.push(...element.products);
            }
            setProducts(products);

            setTotalQty(ltotalQty);
            setTotalReceivedQty(ltotalReceivedQty);
            setTotalShippedQty(ltotalShippedQty);
            setTotalNotShippedQty(lttoalNotShippedQty);
            setTotalRemainingQty(lttoalRemainingQty);

            let lsparePartsTotalQty = 0;
            let lsparePartsTotalReceivedQty = 0;
            let lsparePartsTotalShippedQty = 0;
            let lsparePartsTotalNotShippedQty = 0;
            let lsparePartsTotalRemainingQty = 0;
            for (let i = 0; i < lPartsShippingData.length; i++) {
                const element = lPartsShippingData[i];
                lsparePartsTotalQty += element?.qtyOrdered;
                lsparePartsTotalReceivedQty += element.qtyReceived;
                lsparePartsTotalShippedQty += element.qtyShipped;
                lsparePartsTotalNotShippedQty += element.qtyNotShipped;
                lsparePartsTotalRemainingQty += element.qtyRemaining;

                for (let j = 0; j < element.products.length; j++) {
                    element.products[j].soName = element.name;
                }
                products.push(...element.products);
            }
            setSparePartsTotalQty(lsparePartsTotalQty);
            setSparePartsTotalReceivedQty(lsparePartsTotalReceivedQty);
            setSparePartsTotalShippedQty(lsparePartsTotalShippedQty);
            setSparePartsTotalNotShippedQty(lsparePartsTotalNotShippedQty);
            setSparePartsTotalRemainingQty(lsparePartsTotalRemainingQty);

            setProducts(products);
        } catch (error) {
            console.error("Error loading shipping data:", error);
        } finally {
            setLoading(false);
        }
    }

    const getStatus = function (row: any) {
        if (row.request_do_date) {
            return "Ready For Delivery";
        } else if (row.ship_arrived_date) {
            return "Customs Clearance";
        } else if (row.state == "purchase" || row.original_bl_date) {
            return "In Transit Sea";
        } else if (row.state == "draft" || row.stae == "sent") {
            return "Preparing for export";
        } else {
            return "-";
        }
    };

    // Update the exportData function similarly
    const exportToCSV = (dataset1: any[], dataset2: any[]) => {
        // 1. Combine and Flatten the data
        const combinedData = [...dataset1, ...dataset2];

        const rows = combinedData.flatMap((po) =>
            po.products.map((p: any) => ({
                "SO Name": po.name, // Parent data
                "Product Name": p.name, // Nested data
                "Qty Ordered": p.qtyOrdered,
                "Qty Shipped": p.qtyShipped,
                "Qty Delivered": p.qtyReceived, // Renamed as requested
                ETA: p.eta,
                "Ship Arrived Date": p.ship_arrived_date,
                Status: getStatus(p),
            })),
        );

        // 2. Convert to CSV string
        // json-2-csv is now functional and doesn't require complex config classes
        const csv = json2csv(rows, {
            emptyFieldValue: "N/A",
            keys: [
                "SO Name",
                "Product Name",
                "Qty Ordered",
                "Qty Shipped",
                "Qty Delivered",
                "ETA",
                "Ship Arrived Date",
                "Status",
            ],
        });

        // 3. Trigger Download in Browser
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.setAttribute("href", url);
        link.setAttribute(
            "download",
            `shipping_report_${new Date().toLocaleDateString()}.csv`,
        );
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleScroll = (source: any, target: any) => {
        if (isSyncing.current) return;

        isSyncing.current = true;

        if (source.current && target.current) {
            target.current.scrollTop = source.current.scrollTop;
        }

        requestAnimationFrame(() => {
            isSyncing.current = false;
        });
    };

    useEffect(() => {
        // Load daily data by default
        loadShippingData();
    }, []);

    useEffect(() => {
        if (!search) {
            // handleClearSearch();
        }
    }, [search]);

    useEffect(() => {
        const shippedList: any[] = [];
        const receivedList: any[] = [];

        for (let i = 0; i < shippingData.length; i++) {
            const shippingItem = shippingData[i];

            const shippedProducts: any[] = [];
            const receivedProducts: any[] = [];

            for (let j = 0; j < shippingItem.products.length; j++) {
                const product = shippingItem.products[j];

                if (product.qtyShipped > 0) {
                    shippedProducts.push(product);
                }

                if (product.qtyReceived > 0) {
                    receivedProducts.push(product);
                }
            }

            if (shippedProducts.length > 0) {
                shippedList.push({
                    ...shippingItem,
                    products: shippedProducts,
                });
            }

            if (receivedProducts.length > 0) {
                receivedList.push({
                    ...shippingItem,
                    products: receivedProducts,
                });
            }
        }

        let ltotalShippedQty = 0;
        for (let i = 0; i < shippedList.length; i++) {
            const element = shippedList[i];
            ltotalShippedQty += element?.qtyOrdered;
        }

        let ltotalReceivedQty = 0;
        for (let i = 0; i < receivedList.length; i++) {
            const element = shippedList[i];
            ltotalReceivedQty += element?.qtyOrdered;
        }

        setShippedShippingData(shippedList);
        setReceivedShippingData(receivedList);
        setTotalFilteredShippedQty(ltotalShippedQty);
        setTotalFilteredReceivedQty(ltotalReceivedQty);
    }, [shippingData]);

    return (
        <div className="min-vh-100" style={{ overflow: "hidden", zoom: 0.6 }}>
            <div className="container-fluid">
                <div
                    className="card"
                    style={{
                        marginTop: "1rem",
                        marginBottom: 100,
                        borderWidth: 1,
                        borderColor: "#d8d8d8ff",
                    }}
                >
                    {loading ? (
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ minHeight: "190vh" }}
                        >
                            <div className="text-center">
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                    style={{
                                        width: "3rem",
                                        height: "3rem",
                                    }}
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </div>
                                <p className="mt-3 text-muted">
                                    Loading shipping data...
                                </p>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div
                                style={{
                                    position: "relative",
                                    overflowY: "hidden",
                                    overflowX: "hidden",
                                }}
                            >
                                {shippingData.length > 0 ? (
                                    <div
                                        style={{
                                            display: "flex",
                                        }}
                                    >
                                        {/* Scrollable columns - reduced width */}
                                        <div
                                            className="scrollbar-hide"
                                            style={{
                                                display: "flex",
                                                flexShrink: 0,
                                                backgroundColor: "white",
                                                maxWidth: "60%",
                                                overflowY: "scroll",
                                            }}
                                            ref={leftScrollRef}
                                            onScroll={() =>
                                                handleScroll(
                                                    leftScrollRef,
                                                    rightScrollRef,
                                                )
                                            }
                                        >
                                            <CustomerInfoTable
                                                shippingInfoColumns={
                                                    shippingInfoColumns
                                                }
                                                products={products}
                                            />
                                        </div>
                                        <div
                                            className="scrollbar-hide"
                                            style={{
                                                display: "flex",
                                                flex: 1,
                                                flexShrink: 0,
                                                backgroundColor: "white",
                                                width: "40%",
                                                overflowY: "scroll",
                                                borderLeft: "1px solid #efefef",
                                                paddingBottom: 35,
                                            }}
                                            ref={rightScrollRef}
                                            onScroll={() =>
                                                handleScroll(
                                                    rightScrollRef,
                                                    leftScrollRef,
                                                )
                                            }
                                        >
                                            <OrderStatusView
                                                products={products}
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            height: "70vh",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: 16,
                                            color: "#525252ff",
                                        }}
                                    >
                                        No Data Found
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>
            <style>{`

                .scrollbar-hide::-webkit-scrollbar {
                display: none;
                }
                .table-hover tbody tr:hover {
                background-color: #f8f9fa;
                }
                
                div[style*="overflowX: scroll"]::-webkit-scrollbar {
                height: 8px;
                }
                
                div[style*="overflowX: scroll"]::-webkit-scrollbar-track {
                background: #f7fafc;
                border-radius: 4px;
                }
                
                div[style*="overflowX: scroll"]::-webkit-scrollbar-thumb {
                background: #cbd5e0;
                border-radius: 4px;
                }
                
                div[style*="overflowX: scroll"]::-webkit-scrollbar-thumb:hover {
                background: #a0aec0;
                }
            `}</style>
        </div>
    );
};

export default CustomerShippingViewFullScreen;
